var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLouban(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4117_6016)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 16,
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 1,
    height: 16,
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 1,
    height: 16,
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65139 6.5L6.15139 3.5H14.3486L9.84861 6.5H1.65139Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65139 12.5L6.15139 9.5H14.3486L9.84861 12.5H1.65139Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 1,
    height: 16,
    fill: "#7C7C7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4117_6016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLouban);
export default __webpack_public_path__ + "static/media/louban.501d5b308e68e5c2e505e08955b073b9.svg";
export { ForwardRef as ReactComponent };